import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ProtocoloBioseguridad = () => {
  const [protocolobioseguridadData, setProtocoloBioseguridadData] = useState([]);

  useEffect(() => {
    // Función para obtener datos desde el servidor
    const fetchProtocoloBioseguridadData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/protocolobioseguridad`); // Cambia la ruta según tu configuración de servidor
        setProtocoloBioseguridadData(response.data);
      } catch (error) {
        console.error('Error fetching protocolo de bioseguridad data:', error);
      }
    };

    fetchProtocoloBioseguridadData(); // Llama a la función para obtener los datos cuando el componente se monte
  }, []);

  return (
    <div className="">
      {protocolobioseguridadData.map((item) => (
        <div key={item._id} className="">
          <div 
            className='singlebackground' 
            style={{
              backgroundImage: `url(/media/${item.image})`,          
            }}
          ></div>
          <div className="singlebackground-text animated-text ">
            <h2>Protocolo de bioseguridad</h2>
            <p>Protocolo de Bioseguridad institucional establecido</p>
          </div>
          <div className='container'>
            <div className="caption">
              <h2 className='p-5 text-primary text-center fw-bold'>{item.title}</h2>
            </div>
            <div className="p-5 mt-3 bg-gradient bg-opacity-50">
              {/* <h3 className='text-primary text-center fw-bold'>{item.titleone}</h3> */}
              <p className='text-justify'>{item.string}</p>
            </div>
            <div className="p-5 mt-3 bg-primary bg-gradient bg-opacity-50">
              <h3 className='text-primary text-center fw-bold'>{item.titleone}</h3>
              <a class="btn btn-primary" href={item.stringtwo} target="_blank" rel="noopener noreferrer" role="button">Ir a encuesta</a>
            </div> 
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProtocoloBioseguridad;
